import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AttachmentTagLabelWrapper = styled.span`
  display: grid;
  align-items: center;
  gap: ${Spacing.S4};
  grid-auto-flow: column;
  height: 24px;
  white-space: nowrap;
`
